const VERSION: string = '0.1.0-release.21858';
export default VERSION;
